import { FC } from 'react'
import ActionButton, { ActionButtonProps } from './ActionButton'
import Spinner from './Spinner'

type CSVButtonProps = {
  disabled: boolean
  isLoading: boolean
  onExportToCSV: () => void
  text?: string
  type?: ActionButtonProps['type']
}

const CSVButton: FC<CSVButtonProps> = ({
  disabled,
  isLoading,
  onExportToCSV,
  text = 'Export to CSV',
  type = 'primary',
}) => (
  <ActionButton
    type={type}
    padding="lg"
    ariaLabel="Export to CSV"
    disabled={disabled}
    onClick={onExportToCSV}
    styles={`w-[120px] h-8 ${disabled && !isLoading ? 'opacity-80' : ''}`}
  >
    {isLoading ? <Spinner className="h-8 stroke-white" /> : text}
  </ActionButton>
)

export default CSVButton
